export default __webpack_public_path__ + "static/media/cif-mg.d07196fb.svg";